import { render } from "./GlobalComponent.vue?vue&type=template&id=aa059438&ts=true"
import script from "./GlobalComponent.vue?vue&type=script&lang=ts"
export * from "./GlobalComponent.vue?vue&type=script&lang=ts"

import "./GlobalComponent.vue?vue&type=style&index=0&id=aa059438&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__